import { Observable } from "rxjs";

import { OrdersRepository } from "lib/repositories/index";
import st from "lib/utils/index";

export const OPEN = "orders/EditOrderInstallmentsModal/OPEN";
export const CLOSE = "orders/EditOrderInstallmentsModal/CLOSE";
export const UPDATE_ORDER = "orders/EditOrderInstallmentsModal/UPDATE_ORDER";
export const VALIDATE = "orders/EditOrderInstallmentsModal/VALIDATE";
export const SUBMIT = "orders/EditOrderInstallmentsModal/SUBMIT";
export const FETCH_SUBMIT_START = "orders/EditOrderInstallmentsModal/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "orders/EditOrderInstallmentsModal/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "orders/EditOrderInstallmentsModal/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.orders.EditOrderInstallmentsModal;

const initialState = {
  opened: false,
  initialOrder: null,
  order: null,
  errors: new st.form.ValidationErrors(),
  valid: true,
  submitLoading: false,
  saved: false,
};

const reducers = {
  [OPEN]: (state, { order }) => {
    return {
      ...initialState,
      opened: true,
      initialOrder: order,
      order,
    };
  },

  [CLOSE]: (state) => {
    return {
      ...state,
      opened: false,
    };
  },

  [UPDATE_ORDER]: (state, { order }) => {
    return {
      ...state,
      order,
    };
  },

  [VALIDATE]: (state) => {
    const { order } = state;
    const errors = new st.form.ValidationErrors();

    // customOrderItems.forEach(item => {
    //   errors.add(`customOrderItems[${item.uuid}].name`, st.validators.presence(item.name))
    //   errors.add(`customOrderItems[${item.uuid}].total_price`, st.validators.presence(item.total_price.value))
    //   errors.add(`customOrderItems[${item.uuid}].total_price`, st.validators.presence(item.total_price.currency))
    // })

    if (errors.length > 0) {
      errors.add("base", I18n.t("papp.common.form_validation_error_message"));
    }

    return {
      ...state,
      errors,
      valid: errors.valid,
    };
  },

  [FETCH_SUBMIT_START]: (state) => {
    return {
      ...state,
      submitLoading: true,
      errors: new st.form.ValidationErrors(),
    };
  },

  [FETCH_SUBMIT_SUCCESS]: (state, { order }) => {
    return {
      ...state,
      initialOrder: order,
      saved: true,
      submitLoading: false,
    };
  },

  [FETCH_SUBMIT_FAILURE]: (state, { errors }) => {
    return {
      ...state,
      submitLoading: false,
      errors,
    };
  },
};

const epics = [
  (actions$, { getState, dispatch }) =>
    actions$
      .ofType(SUBMIT)
      .switchMap(() => {
        setTimeout(() => {
          dispatch(validate());
        });
        return actions$.ofType(VALIDATE).take(1);
      })
      .filter(() => {
        const { valid } = stateSelector(getState());
        return valid;
      })
      .flatMap(() => {
        const { order, initialOrder } = stateSelector(getState());
        const serializeOrder = (order) => ({
          id: order.id,
          token: order.token,
          installments: order.installments,
        });
        return Observable.concat(
          Observable.of({ type: FETCH_SUBMIT_START }),
          OrdersRepository.update(serializeOrder(order), serializeOrder(initialOrder))
            .map((order) => {
              return { type: FETCH_SUBMIT_SUCCESS, order };
            })
            .catch((error) => {
              st.api.handleError(error, { getState, dispatch });
              const errors = new st.form.ValidationErrors([["base", st.api.findResponseErrorMessage(error)]]);
              return Observable.of({
                type: FETCH_SUBMIT_FAILURE,
                errors,
                error,
              });
            })
        );
      }),
];

export function open(order) {
  return { type: OPEN, order };
}

export function close() {
  return { type: CLOSE };
}

export function updateOrder(order) {
  return { type: UPDATE_ORDER, order };
}

export function validate({ submitValidate = false } = {}) {
  return { type: VALIDATE, submitValidate };
}

export function submit() {
  return { type: SUBMIT };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/orders/EditOrderInstallmentsModal/index.js